<div style="padding:10px;">
    <div style="padding-bottom:10px;">
        <h2>Account inactive for {{inactiveTime}} minutes...</h2>
    </div>
    <div>
        You will be logged out in {{secondCount}} second(s).
    </div>
</div>